<template>
    <ModalContainer v-if="visible">
        <div>
            <div class="form-group text-white">
                {{ $t("setting.old_password") }}
                <div class="mt-2 input-group">
                    <input
                        class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                        v-model="password.old"
                    />
                </div>
                <span class="text-danger">{{ errors.old }}</span>
            </div>
            <div class="form-group text-white">
                {{ $t("setting.new_password") }}
                <div class="mt-2 input-group">
                    <input
                        class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                        v-model="password.new"
                    />
                </div>
                <span class="text-red-500 text-xs mt-1">{{
                    errors.new
                    }}</span>
            </div>
            <div class="form-group text-white">
                {{ $t("setting.confirm_password") }}
                <div class="mt-2 input-group">
                    <input
                        class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                        v-model="password.confirm"
                    />
                </div>
                <span class="text-red-500 text-xs mt-1">{{
                    errors.confirm || errors.confirmPassword
                    }}</span>
            </div>
            <div class="flex justify-between mt-5">
                <button
                    class="px-4 py-2 border border-purple-400 text-purple-400 !rounded-full whitespace-nowrap"
                    @click="$emit('close')"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="px-4 py-2 bg-purple-500 !rounded-full whitespace-nowrap"
                    @click="changeNewPassword"
                >
                    <div v-if="!isConfirm">
                        {{ $t("setting.update") }}
                    </div>

                    <Loading
                        color="#ffffff"
                        v-if="isConfirm"
                        size="24"
                        class="px-4 py-0"
                    />
                </button>
            </div>
        </div>
    </ModalContainer>
</template>

<script>
import { Dialog, Toast } from 'vant';
import ModalContainer from '../ModalContainer.vue';

export default {
    components: {
        ModalContainer
    },
    props: {
        visible: { type: Boolean, default: false },
    },
    data() {
        return {
            password: {
                user_id: this.$store.state.authUser.id,
            },
            isConfirm: false,
            errors: {},
        }
    },
    methods: {
        changeNewPassword() {
            this.errors = {};
            if (!this.password.old) {
                this.errors.old =
                    this.$store.state.language === "en"
                        ? "Old password required"
                        : "လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။";
                return false;
            }
            if (!this.password.new) {
                this.errors.new =
                    this.$store.state.language === "en"
                        ? "New password required"
                        : "လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။";
                return false;
            }
            if (!this.password.confirm) {
                this.errors.confirm =
                    this.$store.state.language === "en"
                        ? "Confirm password required"
                        : "အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။";
                return false;
            }
            if (this.password.new !== this.password.confirm) {
                this.errors.confirmPassword =
                    this.$store.state.language === "en"
                        ? "New passwords not match"
                        : "လျှို့ဝှက်နံပါတ် မတူညီပါ။";
                return false;
            }
            this.isConfirm = true;
            Dialog.confirm({
                title:
                    this.$store.state.language === "en"
                        ? "Are you sure?"
                        : "သေချာပါသလား?",
                cancelButtonText:
                    this.$store.state.language === "en" ? "Cancel" : "မလုပ်တော့ပါ။",
                confirmButtonText:
                    this.$store.state.language === "en" ? "Sure" : "သေချာပြီ။",
            })
                .then(() => {
                    this.updateUser();
                })
                .catch(() => { });
            this.isConfirm = false;
            return true;
        },
        async updateUser() {
            try {
                const res = await axios.post(
                    "/auth/userPasswordChange",
                    this.password,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );
                Toast.success(
                    this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
                );
                this.password = {};
                this.errors = {};
                $("#editUserPassword").modal("hide");
                this.$emit("close");
            } catch (error) {
                Toast.fail(
                    this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။"
                );
            }
        },
    }
}
</script>